export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center space-y-4">
        <div className="text-6xl">📱</div>
        <h1 className="text-xl font-bold text-gray-900">잘못된 QR 코드입니다</h1>
        <p className="text-gray-600">유효하지 않은 주소입니다. QR 코드를 다시 확인해주세요.</p>
      </div>
    </div>
  )
}
